import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { LEADER_EXPERTISE_DELETE } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

export const api_leader_delete_expertise = (data) => {
    return (dispatch, getState) => {

        return axios.delete(`${Config.API_BASE_URL}/leader/${data.leaderId}/market-expertise/${data.id}`)
        .then(response => {

            dispatch({
                type: LEADER_EXPERTISE_DELETE,
                payload: response.data
            });

        })
        .catch(error => {

            dispatch({
                type: LEADER_EXPERTISE_DELETE,
                payload: {
                    marketExpertise: {
                        errors: error.response.data
                    }
                }
            });
        });
    };
}

export default api_leader_delete_expertise;